// Estilos adaptables para la aplicación de Axon Capital

export const styles = {
  // --- Colores y Fuentes ---
  colors: {
    primary: '#1A283E', // Azul Axon
    secondary: '#0D1A29', // Negro Axon
    background: '#F6F7F6', // Blanco Axon
    gray: '#E5E7EB',
    lightGray: '#F9FAFB',
    mediumGray: '#6B7281', // Un gris intermedio para texto inactivo
    accent: '#4F46E5',
    yellow: '#FEF9C3',
    green: '#D1FAE5',
    red: '#FEE2E2',
    redText: '#991B1B',
  },
  body: {
    backgroundColor: '#F6F7F6',
    color: '#0D1A29',
    fontFamily: "'Roboto', sans-serif",
    margin: 0,
    minHeight: '100vh',
  },
  logo: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: '600',
    fontSize: '1.5rem',
    color: '#1A283E',
  },

  // --- Encabezado ---
  header: {
    backgroundColor: '#FFFFFF',
    padding: '1rem 2rem',
    borderBottom: '1px solid #E5E7EB',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  headerMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1.5rem',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    flexWrap: 'wrap',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    flexWrap: 'wrap',
  },
  headerRightMobile: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },

  // --- Contenido Principal ---
  main: {
    padding: '2rem',
  },
  mainMobile: {
    padding: '1rem',
  },

  // --- Pestañas y Tablas ---
  tabContainer: {
    marginBottom: '1.5rem',
    borderBottom: '1px solid #D1D5DB',
    width: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  },
  tab: {
    padding: '0.75rem 0.25rem',
    margin: '0 1.25rem',
    cursor: 'pointer',
    borderBottom: '3px solid transparent',
    color: '#6B7281',
    fontWeight: '500',
    background: 'none',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    fontSize: '1rem',
    transition: 'color 0.2s ease-in-out, border-color 0.2s ease-in-out',
    ':hover': {
        color: '#1A283E',
    }
  },
  activeTab: {
    color: '#1A283E',
    fontWeight: '700',
    borderBottom: `3px solid ${'#1A283E'}`,
  },
  tableContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '0.5rem',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1200px',
  },
  th: {
    backgroundColor: '#F9FAFB',
    padding: '0.75rem 1rem',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '0.75rem',
    fontWeight: '600',
    color: '#374151',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    cursor: 'pointer',
    userSelect: 'none',
  },
  td: {
    padding: '1rem 1rem',
    borderBottom: '1px solid #E5E7EB',
    fontSize: '0.875rem',
    color: '#374151',
    textAlign: 'center',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  // Columnas de contenido corto (ej: Hora): ocupan el mínimo ancho posible.
  narrowCol: {
    paddingLeft: '0.4rem',
    paddingRight: '0.4rem',
    width: '1%',
    whiteSpace: 'nowrap',
  },
  thMav: {
    backgroundColor: '#F3F4F6',
  },
  tdMav: {
    backgroundColor: '#F9FAFB',
  },
  clickableText: {
    cursor: 'pointer',
    color: '#4F46E5', // accent color
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
  },

  // --- Botones y Formularios ---
  button: {
    backgroundColor: '#1A283E',
    color: '#FFFFFF',
    padding: '0.6rem 1.2rem',
    borderRadius: '0.375rem',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    transition: 'background-color 0.3s',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    justifyContent: 'center',
  },
  buttonMobile: {
    width: '100%',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '1rem',
  },
  modalContent: {
    backgroundColor: '#FFFFFF',
    padding: '2rem',
    borderRadius: '0.5rem',
    width: '100%',
    maxWidth: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    zIndex: 1001,
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    border: '1px solid #D1D5DB',
    borderRadius: '0.375rem',
    marginTop: '0.25rem',
    boxSizing: 'border-box',
  },
  select: {
    width: '100%',
    padding: '0.75rem',
    border: '1px solid #D1D5DB',
    borderRadius: '0.375rem',
    marginTop: '0.25rem',
    backgroundColor: 'white',
    boxSizing: 'border-box',
  },
  label: {
    fontWeight: '600',
    fontSize: '0.875rem',
    color: '#374151',
    display: 'block',
  },
  iconButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '0.25rem',
    margin: '0 0.25rem',
  },

  // --- Estilos para la Notificación ---
  notification: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    backgroundColor: '#FFFFFF',
    color: '#1A283E',
    padding: '1rem 1.5rem',
    borderRadius: '0.5rem',
    boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    transform: 'translateX(calc(100% + 20px))',
    transition: 'transform 0.5s ease-in-out',
  },
  notificationVisible: {
    transform: 'translateX(0)',
  },
  notificationCloseButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    color: '#727B88',
    cursor: 'pointer',
    padding: '0 0.5rem',
  },

  // --- Estilos para los Indicadores (KPIs) ---
  kpiContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', // <-- CAMBIO: Se reduce el tamaño mínimo
    gap: '1rem',
    marginBottom: '2rem',
  },
  kpiCard: {
    backgroundColor: '#FFFFFF',
    padding: '1rem', // <-- CAMBIO: Se reduce el padding
    borderRadius: '0.5rem',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  },
  kpiTitle: {
    margin: 0,
    fontWeight: '600',
    fontSize: '0.75rem', // <-- CAMBIO: Se reduce el tamaño de fuente
    color: '#6B7281',
    textTransform: 'uppercase',
  },
  kpiValue: {
    margin: '0.25rem 0 0 0', // <-- CAMBIO: Se reduce el margen superior
    fontWeight: '700',
    fontSize: '1.5rem', // <-- CAMBIO: Se reduce el tamaño de fuente
    color: '#1A283E',
  },
};